import React from 'react';

// Free Tier - Lock/Padlock (Basic Access)
export const FreeTierIcon = ({ className = "w-8 h-8", color = "currentColor" }) => (
  <svg 
    viewBox="0 0 64 64" 
    className={className} 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Padlock body */}
    <rect x="12" y="28" width="40" height="30" rx="4" fill={color} opacity="0.2" stroke={color} strokeWidth="2.5"/>
    {/* Keyhole */}
    <circle cx="32" cy="40" r="4" fill={color}/>
    <rect x="30" y="42" width="4" height="8" rx="1" fill={color}/>
    {/* Shackle */}
    <path 
      d="M20 28V22C20 15.373 25.373 10 32 10C38.627 10 44 15.373 44 22V28" 
      stroke={color} 
      strokeWidth="3" 
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

// Bronze Tier - Case Folder (Entry Level Detective)
export const BronzeTierIcon = ({ className = "w-8 h-8", color = "currentColor" }) => (
  <svg 
    viewBox="0 0 64 64" 
    className={className} 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Folder back */}
    <path 
      d="M8 18C8 15.791 9.791 14 12 14H26L30 20H52C54.209 20 56 21.791 56 24V50C56 52.209 54.209 54 52 54H12C9.791 54 8 52.209 8 50V18Z" 
      fill={color} 
      opacity="0.2"
      stroke={color} 
      strokeWidth="2.5"
    />
    {/* Tab */}
    <path 
      d="M8 18C8 15.791 9.791 14 12 14H24L28 20H8V18Z" 
      fill={color} 
      opacity="0.4"
    />
    {/* Case file paper lines */}
    <line x1="16" y1="30" x2="48" y2="30" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <line x1="16" y1="38" x2="40" y2="38" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <line x1="16" y1="46" x2="44" y2="46" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    {/* Confidential stamp effect */}
    <rect x="36" y="40" width="14" height="10" rx="1" fill={color} opacity="0.3" transform="rotate(-10 43 45)"/>
  </svg>
);

// Silver Tier - Magnifying Glass (Investigator)
export const SilverTierIcon = ({ className = "w-8 h-8", color = "currentColor" }) => (
  <svg 
    viewBox="0 0 64 64" 
    className={className} 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Magnifying glass lens */}
    <circle 
      cx="26" 
      cy="26" 
      r="16" 
      fill={color} 
      opacity="0.15"
      stroke={color} 
      strokeWidth="3"
    />
    {/* Glass reflection */}
    <path 
      d="M18 18C20 16 23 15 26 15" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round"
      opacity="0.5"
    />
    {/* Handle */}
    <line 
      x1="38" 
      y1="38" 
      x2="54" 
      y2="54" 
      stroke={color} 
      strokeWidth="5" 
      strokeLinecap="round"
    />
    {/* Fingerprint inside lens */}
    <path 
      d="M22 26C22 23 24 21 27 21M20 26C20 22 23 19 27 19M24 26C24 24 25 23 27 23" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round"
      opacity="0.6"
    />
  </svg>
);

// Gold Tier - Detective Badge (Full Access)
export const GoldTierIcon = ({ className = "w-8 h-8", color = "currentColor" }) => (
  <svg 
    viewBox="0 0 64 64" 
    className={className} 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Star badge shape */}
    <path 
      d="M32 4L38 20H56L42 32L48 50L32 40L16 50L22 32L8 20H26L32 4Z" 
      fill={color} 
      opacity="0.25"
      stroke={color} 
      strokeWidth="2.5"
      strokeLinejoin="round"
    />
    {/* Inner shield */}
    <path 
      d="M32 16L36 24H44L38 30L40 38L32 34L24 38L26 30L20 24H28L32 16Z" 
      fill={color} 
      opacity="0.4"
    />
    {/* Center circle */}
    <circle cx="32" cy="28" r="6" fill={color} opacity="0.6"/>
    {/* Bottom banner shape */}
    <path 
      d="M18 52H46C48 52 48 56 46 56H18C16 56 16 52 18 52Z" 
      fill={color} 
      opacity="0.3"
    />
    {/* Three dots to indicate "full" */}
    <circle cx="28" cy="54" r="1.5" fill={color} opacity="0.8"/>
    <circle cx="32" cy="54" r="1.5" fill={color} opacity="0.8"/>
    <circle cx="36" cy="54" r="1.5" fill={color} opacity="0.8"/>
  </svg>
);

// Alternative icon set for variety

// Evidence Bag Icon (for Free tier alternative)
export const EvidenceBagIcon = ({ className = "w-8 h-8", color = "currentColor" }) => (
  <svg 
    viewBox="0 0 64 64" 
    className={className} 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Bag */}
    <path 
      d="M14 20H50L46 58H18L14 20Z" 
      fill={color} 
      opacity="0.2"
      stroke={color} 
      strokeWidth="2.5"
    />
    {/* Seal */}
    <rect x="14" y="16" width="36" height="8" rx="2" fill={color} opacity="0.4" stroke={color} strokeWidth="2"/>
    {/* Evidence label */}
    <rect x="22" y="32" width="20" height="16" rx="2" fill={color} opacity="0.3"/>
    <line x1="26" y1="37" x2="38" y2="37" stroke={color} strokeWidth="1.5"/>
    <line x1="26" y1="42" x2="34" y2="42" stroke={color} strokeWidth="1.5"/>
  </svg>
);

// Revolver Icon (for premium tier)
export const RevolverIcon = ({ className = "w-8 h-8", color = "currentColor" }) => (
  <svg 
    viewBox="0 0 64 64" 
    className={className} 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Barrel */}
    <rect x="34" y="22" width="24" height="8" rx="2" fill={color} opacity="0.3" stroke={color} strokeWidth="2"/>
    {/* Cylinder */}
    <circle cx="30" cy="26" r="10" fill={color} opacity="0.2" stroke={color} strokeWidth="2.5"/>
    {/* Cylinder chambers */}
    <circle cx="30" cy="26" r="3" stroke={color} strokeWidth="1.5" fill="none"/>
    <circle cx="30" cy="19" r="2" fill={color} opacity="0.4"/>
    <circle cx="36" cy="23" r="2" fill={color} opacity="0.4"/>
    <circle cx="36" cy="29" r="2" fill={color} opacity="0.4"/>
    <circle cx="30" cy="33" r="2" fill={color} opacity="0.4"/>
    <circle cx="24" cy="29" r="2" fill={color} opacity="0.4"/>
    <circle cx="24" cy="23" r="2" fill={color} opacity="0.4"/>
    {/* Grip */}
    <path 
      d="M20 32L16 48C15 52 18 54 22 52L28 36" 
      fill={color} 
      opacity="0.3"
      stroke={color} 
      strokeWidth="2.5"
    />
    {/* Trigger guard */}
    <path 
      d="M26 32C26 36 24 40 20 40" 
      stroke={color} 
      strokeWidth="2"
      fill="none"
    />
  </svg>
);

// Binoculars Icon (for Silver tier alternative)
export const BinocularsIcon = ({ className = "w-8 h-8", color = "currentColor" }) => (
  <svg 
    viewBox="0 0 64 64" 
    className={className} 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Left lens */}
    <circle cx="20" cy="32" r="14" fill={color} opacity="0.2" stroke={color} strokeWidth="2.5"/>
    <circle cx="20" cy="32" r="8" fill={color} opacity="0.15"/>
    {/* Right lens */}
    <circle cx="44" cy="32" r="14" fill={color} opacity="0.2" stroke={color} strokeWidth="2.5"/>
    <circle cx="44" cy="32" r="8" fill={color} opacity="0.15"/>
    {/* Bridge */}
    <rect x="28" y="28" width="8" height="8" rx="2" fill={color} opacity="0.4" stroke={color} strokeWidth="2"/>
    {/* Eye cups */}
    <path d="M6 32C6 28 10 26 14 26" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M58 32C58 28 54 26 50 26" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
  </svg>
);

// Main function to get tier icon by name
export const getTierIcon = (tierName, size = "w-8 h-8") => {
  const icons = {
    'Free': <FreeTierIcon className={size} />,
    'Bronze': <BronzeTierIcon className={size} />,
    'Silver': <SilverTierIcon className={size} />,
    'Gold': <GoldTierIcon className={size} />,
  };
  return icons[tierName] || <FreeTierIcon className={size} />;
};

export default getTierIcon;
